import { Link } from "react-router-dom"

const QuizzesQuickActions = () => {
  return (
    <>
      <div className="card-quizzes my-5 mx-md-5 mx-3">
        <div className="card-body p-4">
          <h5 className="text-white fw-bold mb-3">🚀 Quick Actions</h5>
          <div className="row mx-0 g-3">
            <div className="col-md-3 col-6 d-flex align-items-stretch">
              <Link className="btn btn-outline-light w-100 p-3" to="/assessment-flow">
                <div className="fs-4 mb-2">📊</div>
                <div>Create Assessment</div>
              </Link>
            </div>
            <div className="col-md-3 col-6 d-flex align-items-stretch">
              <Link className="btn btn-outline-light w-100 p-3" to="/preparation-flow">
                <div className="fs-4 mb-2">📚</div>
                <div>Study Path</div>
              </Link>
            </div>
            <div className="col-md-3 col-6 d-flex align-items-stretch">
              <Link className="btn btn-outline-light w-100 p-3" to="/skills-certificate"><div className="fs-4 mb-2">🏆</div>
                <div>Certificates</div>
              </Link>
            </div>
            <div className="col-md-3 col-6 d-flex align-items-stretch">
              <Link className="btn btn-outline-light w-100 p-3" to="/Tournaments">
                <div className="fs-4 mb-2">⚔️</div>
                <div>Tournaments</div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default QuizzesQuickActions